import { useEffect } from 'react';

const WIDGET_KEY = import.meta.env.VITE_CHAT_WIDGET_KEY as string | undefined;
const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? '';

/**
 * Injects the chat widget script tag once when VITE_CHAT_WIDGET_KEY is set.
 * Uses the same API origin as the rest of the app for the widget bundle URL.
 * No-ops silently when the key is absent (dev/CI without a configured widget).
 */
export function ChatWidgetLoader(): null {
  useEffect(() => {
    if (!WIDGET_KEY) return;

    const existing = document.getElementById('ai-receptionist-chat-script');
    if (existing) return;

    const script = document.createElement('script');
    script.id = 'ai-receptionist-chat-script';
    script.src = `${API_URL}/api/chat/widget.js`;
    script.setAttribute('data-chat-key', WIDGET_KEY);
    script.setAttribute('data-theme', 'light');
    script.setAttribute('data-position', 'bottom-right');
    script.setAttribute('data-api', `${API_URL}/api`);
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
